export default __webpack_public_path__ + "71405f0470bb41e7001253fcac31318b.png";